// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6GTri","footer--fixed":"Footer_footer--fixed__j8h5+","footerContainer":"Footer_footerContainer__0+q0F","footerText":"Footer_footerText__LH04A"};